import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { EventSchema, type Event } from '@casetrace/shared';
import { db } from '../lib/firebase';

export async function fetchCaseEvent(caseId: string, eventId: string): Promise<Event | null> {
  const snapshot = await getDoc(doc(db, 'cases', caseId, 'events', eventId));
  if (!snapshot.exists()) return null;
  return EventSchema.parse({ ...snapshot.data(), id: snapshot.id });
}

/** Hent én hendelse for preview / deep-link fra søk. */
export function useCaseEvent(caseId: string, eventId: string | null | undefined) {
  return useQuery({
    queryKey: ['case-event', caseId, eventId] as const,
    queryFn: () => fetchCaseEvent(caseId, eventId!),
    enabled: Boolean(caseId) && Boolean(eventId),
    staleTime: 60_000,
  });
}
